// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { headerStyles } from "@eisinc/Overrides/Widgets/Budget/BudgetManagementHeader";
import { css } from "styled-components";

headerStyles.titleGridItem = { width: [10, 9, 7, 5, 6] };

headerStyles.buttonsGridItem = {
    width: [2, 3, 5, 7, 6],
    css: css`
        display: flex;
        justify-content: flex-end;
    `,
};

headerStyles.actionButtonsHidden = {
    css: css`
        display: flex;
        @media (max-width: 1024px) and (min-width: 769px) {
            nav {
                margin-left: 22px;
            }
        }
    `,
};

headerStyles.costCodesButton = { variant: "secondary" };

headerStyles.assignBudgetsButton = {
    variant: "secondary",
    css: css`
        margin-left: 10px;
    `,
};
